const handleFetchSpokenLanguageFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.spokenLanguage = action.payload.data;
    state.message = action.payload.message;
};

export {
    handleFetchSpokenLanguageFulfilled
};
